import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.354 22.476L2.994 5.116l1.014-1.014 17.36 17.36-1.014 1.014z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21 3H7.5v2.48L9 6.98V4.5h10.5v12.98l1.376 1.375c.08-.27.124-.558.124-.855V3zm-.93 17.17l-1.062-1.061c-.267.243-.62.391-1.008.391H8.597c.256-.442.403-.954.403-1.5V9.1L7.5 7.6V18c0 .826-.674 1.5-1.5 1.5s-1.5-.674-1.5-1.5v-4.5H6V12H3v6c0 1.654 1.346 3 3 3h12a2.99 2.99 0 002.07-.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.9 12h-1.4v.5l1 1h1.9L11.9 12zm3.62 1.5h.98V12h-2.48l1.5 1.5zm-3-3H18V9h-6.98l1.5 1.5zm-2.02-3H18V6h-7.5v1.5z"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.354 22.476L2.994 5.116l1.014-1.014 17.36 17.36-1.014 1.014z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21 3H7.5v2.48L9 6.98V4.5h10.5v12.98l1.376 1.375c.08-.27.124-.558.124-.855V3zm-.93 17.17l-1.062-1.061c-.267.243-.62.391-1.008.391H8.597c.256-.442.403-.954.403-1.5V9.1L7.5 7.6V18c0 .826-.674 1.5-1.5 1.5s-1.5-.674-1.5-1.5v-4.5H6V12H3v6c0 1.654 1.346 3 3 3h12a2.99 2.99 0 002.07-.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.9 12h-1.4v.5l1 1h1.9L11.9 12zm3.62 1.5h.98V12h-2.48l1.5 1.5zm-3-3H18V9h-6.98l1.5 1.5zm-2.02-3H18V6h-7.5v1.5z"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M40.71 44.953L5.988 10.232l2.028-2.028 34.72 34.72-2.028 2.029z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M42 6H15v4.959l3 3V9h21v25.959l2.752 2.752A5.985 5.985 0 0042 36V6zm-1.861 34.34l-2.123-2.122A2.988 2.988 0 0136 39H17.195A5.963 5.963 0 0018 36V18.201l-3-3V36c0 1.652-1.348 3-3 3s-3-1.348-3-3v-9h3v-3H6v12c0 3.308 2.692 6 6 6h24a5.98 5.98 0 004.139-1.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.799 24H21v1l2 2h3.799l-3-3zm7.242 3H33v-3h-4.959l3 3zm-6-6H36v-3H22.041l3 3zM21 15h15v-3H21v3z"
  }))
};
export var ReceiptNone = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});